<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import URL from '@/api/im/url'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
          this.dataChanage(URL.call.servicedutysetting.del,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        console.log(model);
        //根据是否包含id更新还是添加
        this.dataChanage(URL.call.servicedutysetting.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: '主键', field: 'id',hidden:true},
            { title: '公司id', field: 'companyId',hidden:true},
            { title: '业务组', field: 'businessType',hidden:true},
            { title: '班次名称', field: 'name'},
            { title: '开始时间', field: 'start',type:16},
            { title: '结束时间', field: 'end',type:16},
            { title: '排序', field: 'sort',type:7},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            {click:"查询"},
            {click:"新增"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.call.servicedutysetting.list, //请求路径和参数
          sequence: true,
          isPage: false,
          cols: [
            { title: '主键', field: 'id'},
            { title: '班次名称', field: 'name'},
            { title: '开始时间', field: 'start'},
            { title: '结束时间', field: 'end'},
            { title: '排序', field: 'sort'},
            {title: '操作',btnClick:[
                {name: '修改',click:"update",type:"primary",icon:"el-icon-edit"},
                {name: '删除',click:"delete",type:"primary",icon:"el-icon-delete"},
              ]
            },          ]
        }
      }
    }
  }
</script>
